import type {OrderableDirective} from '../../directives/orderable/orderable.directive';

/**
 * Class used for storing orderable directive instance
 */
export interface GridOrderableCell
{
    /**
     * Instance of orderable directive
     */
    orderable?: OrderableDirective;
}